var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Icon } from 'antd-mobile';
import React from 'react';
import { px2rem } from 'smartpi-core';
import styled from 'styled-components';
import { Flex } from './Flex';
var Container = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100vh;\n"], ["\n  height: 100vh;\n"])));
var IconContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), px2rem(10));
var AppError = function (props) {
    return (React.createElement(Container, null,
        React.createElement(IconContainer, null,
            React.createElement(Icon, { type: "cross-circle", size: "lg", style: { color: 'red' } })),
        React.createElement("div", null, "\u51FA\u9519\u4E86\uFF0C\u8BF7\u91CD\u8BD5\u3002"),
        React.createElement("div", null,
            "\uFF08",
            props.errorMsg,
            "\uFF09")));
};
export { AppError };
var templateObject_1, templateObject_2;
//# sourceMappingURL=AppError.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/components/AppError.js
// module id = 406
// module chunks = 0